import { render } from "./DocumentInspectorActionLink.vue?vue&type=template&id=940b9638&scoped=true"
import script from "./DocumentInspectorActionLink.vue?vue&type=script&lang=js"
export * from "./DocumentInspectorActionLink.vue?vue&type=script&lang=js"

import "./DocumentInspectorActionLink.vue?vue&type=style&index=0&id=940b9638&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-940b9638"]])

export default __exports__